import {BuiltInSourceConfig} from "./built-in-sources";

/** Destinations Onion provides itself — no integration to connect, no key to paste. Typed as
 *  BuiltInSourceConfig so every one of them carries the copy its info modal shows: the info button
 *  renders for anything in this list, so an entry without `infoDescription` is a button that opens
 *  an empty dialog. `category` is inherited from the same type and unused here — the destination
 *  picker is a flat list, only the source grid groups by it. */
export const standardDestinations: BuiltInSourceConfig[] = [
  {
    id: 'respond',
    type: 'respond',
    name: 'Respond to webhook',
    infoDescription: [
      'Return a custom HTTP response to the caller of a webhook-triggered workflow, instead of the default acknowledgment. You control the status code, headers and body sent back.',
      'Use this when the caller expects a synchronous response — for example returning enriched data directly, or signalling success/failure with a specific status code.'
    ],
    category: 'utility',
    endpoint: '',
    description: '',
    createdBy: 'system',
    createdAt: new Date().getTime(),
    lastUpdate: -1,
    lastUpdateBy: '',
    headers: [],
    bodyConstants: [],
    logo: '',
  }, {
    id: 'datamorf',
    type: 'datamorf',
    name: 'Onion workflow',
    infoDescription: [
      'Send this data to another Onion workflow. Chain workflows together instead of building one that does everything.',
      'The receiving workflow runs on its own, with its own history — so a failure there does not fail this run.'
    ],
    category: 'utility',
    endpoint: '',
    description: '',
    createdBy: 'system',
    createdAt: new Date().getTime(),
    lastUpdate: -1,
    lastUpdateBy: '',
    headers: [],
    bodyConstants: [],
    logo: '',
  }, {
    // The workspace's own white-labelled LinkedIn campaigns engine. Built-in rather than an
    // integration: the credential is a workspace token no client may read, so there is nothing to
    // connect. Only offered on linked workspaces — see SelectDestinationComponent.
    id: 'linkedin-campaigns',
    type: 'linkedin-campaigns',
    name: 'LinkedIn Campaigns',
    infoTitle: 'Enrol in LinkedIn Campaigns',
    infoDescription: [
      'Add someone to one of your LinkedIn campaigns, straight from a workflow. The campaign handles the rest — connection request, follow-ups and pacing all run on its own schedule.',
      'Map the person\'s LinkedIn URL and pick the campaign. Custom variables let you feed the campaign\'s message templates from your data: name each one exactly as the template does.',
      'Enrolments are recorded automatically, so they show up on your dashboards without adding a Track step. Someone already in the campaign is left alone rather than counted twice.',
      'Choose "remove" instead to take someone back out of a campaign.'
    ],
    pricingNotes: [
      'Included in your LinkedIn Campaigns plan — enrolling costs nothing beyond the workflow run itself.'
    ],
    category: 'utility',
    endpoint: '',
    description: '',
    createdBy: 'system',
    createdAt: new Date().getTime(),
    lastUpdate: -1,
    lastUpdateBy: '',
    headers: [],
    bodyConstants: [],
    logo: '',
  }, {
    id: 'clay',
    type: 'clay',
    name: 'Clay webhook',
    infoDescription: [
      'Send rows to a Clay table through its webhook URL, so work that starts in Onion can carry on in Clay.',
      'Paste the webhook URL Clay gives you for the table you want to write to.'
    ],
    category: 'utility',
    endpoint: '',
    description: '',
    createdBy: 'system',
    createdAt: new Date().getTime(),
    lastUpdate: -1,
    lastUpdateBy: '',
    headers: [],
    bodyConstants: [],
    logo: '',
  },
  // {
  //   id: 'load-workflow-data',
  //   type: 'load-workflow-data',
  //   name: 'Load workflow data',
  //   endpoint: '',
  //   description: '',
  //   createdBy: 'system',
  //   createdAt: new Date().getTime(),
  //   lastUpdate: -1,
  //   lastUpdateBy: '',
  //   headers: [],
  //   bodyConstants: [],
  //   logo: '',
  // },
  // {
  //   id: 'datamorf-waterfall',
  //   type: 'datamorf-waterfall',
  //   name: 'DataMorf enrichment',
  //   endpoint: '',
  //   description: '',
  //   createdBy: 'system',
  //   createdAt: new Date().getTime(),
  //   lastUpdate: -1,
  //   lastUpdateBy: '',
  //   headers: [],
  //   bodyConstants: [],
  //   logo: '',
  // }
]
